import * as R from 'ramda';
// helpers/constants
import * as G from '../../helpers';
// feature navbar-menu
import configurationTabs from './configs/configuration-tabs';
//////////////////////////////////////////////////

const hexToRgbA = (hexCode, opacity = 1) => {
  if (R.not(G.isString(hexCode))) return null;

  let hex = hexCode.replace('#', '');

  if (R.equals(R.length(hex), 3)) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r},${g},${b},${opacity})`;
};

const filterMenuItemsBySearchCriteria = ({
  sidebar,
  criteria,
  subMenusStatus,
  submenusToggled,
}) => {
  const subMenusExpanded = {...subMenusStatus};

  const filtered = [];

  R.forEach(
    (menuItem) => {
      const { key, title, submenu } = menuItem;

      const submenuCopy = R.clone(submenu);

      const filteredSubmenu = R.filter(
        R.anyPass([
          (subItem) => R.compose(
            R.ifElse(
              G.isNilOrEmpty,
              () => false,
              (tabs) => {
                const filteredTabs = R.filter(
                  R.compose(
                    R.includes(criteria),
                    R.toLower,
                    R.prop('text'),
                  ), tabs);

                if (R.isEmpty(filteredTabs)) return false;

                // eslint-disable-next-line no-param-reassign
                subItem.tabs = filteredTabs;

                return true;
              },
            ),
            R.flip(R.prop)(configurationTabs),
            R.prop('action'),
          )(subItem),
          R.compose(
            R.includes(criteria),
            R.toLower,
            R.prop('title'),
          ),
        ]), submenuCopy);

      const titleIncludes = R.includes(criteria, R.toLower(title));

      if (R.or(titleIncludes, G.isNotNilAndNotEmpty(filteredSubmenu))) {
        filtered.push({
          ...menuItem,
          submenu: filteredSubmenu,
          containedSubItems: G.isNotNilAndNotEmpty(submenu),
        });

        if (R.not(submenusToggled)) {
          subMenusExpanded[key] = true;
        }
      }
    },
    sidebar,
  );

  return {
    subMenusExpanded,
    filteredSideBar: filtered,
  };
};

const getIndexByTabId = (tabId, configTabs) =>
  R.findIndex(R.propEq(tabId, 'tabId'), configTabs);

export {
  hexToRgbA,
  getIndexByTabId,
  filterMenuItemsBySearchCriteria,
};
